import type { DetailPageConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Communications } from "@/src/gql/graphql";
import { communicationsDetailTabs } from "../config/communications-detail-tabs";
import { communicationDetailActions } from "@/lib/actions/definitions";

// ============================================================================
// COMMUNICATIONS DETAIL PAGE CONFIGURATION
// ============================================================================

export const COMMUNICATIONS_DETAIL_CONFIG: DetailPageConfig<Communications> = {
  entity: "communications",
  displayName: "Communication",

  // Tab configurations
  tabs: communicationsDetailTabs,

  // Action configurations
  actions: communicationDetailActions,

  // Breadcrumb configuration
  breadcrumbs: {
    show: true,
    items: [
      { label: "Communications", href: "/communications" },
      {
        label: "Communication Details",
        href: (communication: Communications) => `/communications/${communication.id}`,
        current: true,
      },
    ],
  },

  // Page configuration
  defaultTab: "details",
  showHeader: true,
  showBreadcrumbs: true,
  showActions: true,

  // Title and description templates
  titleTemplate: (item: Communications) => {
    return item.title || `Communication - ${item.type_id || "Unknown"}`;
  },
  descriptionTemplate: (item: Communications) => {
    const direction = (item as any).direction || "Unknown";
    const status = (item as any).status || "Unknown";
    return `${direction} • ${status}`;
  },
};
